import React, { useEffect } from 'react'
import { useSettingsHook } from '../../../../Hooks/communicators/useSettingsHook'
import { Button, TextField } from '@mui/material';
import ImageUploadPreview from '../ImageSelector';
import { loadingButtonClasses } from '@mui/lab';
import { useDispatch, useSelector } from 'react-redux';
import { setOnboardingData } from '../../../../Store/slices/settingsSlice';
import { RootState } from '../../../../Store/store';

export default function Onboarding() {
    const {
        onboardingUpdateButtonLoading,
        updateOnboardingData,
    } = useSettingsHook();
    const dispatch = useDispatch();
    const { onboardingData } = useSelector((state: RootState) => state.settings.value);
    if (onboardingData === null) {
        return <div>Loading...</div>
    };
    return (
        <div className='flex justify-start items-center flex-col w-[50rem]'>
            <p className='text-2xl font-normal mb-4'>Onboarding Data</p>
            <div className='flex justify-center items-center flex-col my-8 w-full'>
                <TextField
                    onChange={(e) => dispatch(setOnboardingData({ ...onboardingData, openingTitle: e.target.value }))}
                    margin='normal'
                    fullWidth
                    label='Opening Title'
                    value={onboardingData.openingTitle}
                    inputMode='text'
                />
                <TextField
                    onChange={(e) => dispatch(setOnboardingData({ ...onboardingData, flow_1_title: e.target.value }))}
                    margin='normal'
                    fullWidth
                    label='Onboarding Page 1 Title'
                    value={onboardingData.flow_1_title}
                    inputMode='text'
                />
                <ImageUploadPreview
                    imageUrl={onboardingData.flow_1_img}
                    which_image='flow_1_img'
                />
                <TextField
                    onChange={(e) => dispatch(setOnboardingData({ ...onboardingData, flow_2_title: e.target.value }))}
                    margin='normal'
                    fullWidth
                    label='Onboarding Page 2 Title'
                    value={onboardingData.flow_2_title}
                    inputMode='text'
                />
                <ImageUploadPreview
                    imageUrl={onboardingData.flow_2_img}
                    which_image='flow_2_img'
                />
                <TextField
                    onChange={(e) => dispatch(setOnboardingData({ ...onboardingData, flow_3_title: e.target.value }))}
                    margin='normal'
                    fullWidth
                    label='Onboarding Page 3 Title'
                    value={onboardingData.flow_3_title}
                    inputMode='text'
                />
                <ImageUploadPreview
                    imageUrl={onboardingData.flow_3_img}
                    which_image='flow_3_img'
                />
            </div>
            <Button
                sx={{
                    marginY: 8,
                    width: '50%',
                }}
                disabled={onboardingUpdateButtonLoading}
                onClick={updateOnboardingData}
                variant='contained'
                color='primary'>
                Save
            </Button>
        </div>
    )
}
